import _defineProperty from "@babel/runtime/helpers/defineProperty";
export default {
  data: function data() {
    return {};
  },
  props: {
    msg: {
      type: String,
      default: '遭遇系统异常，请重试'
    },
    showRefresh: {
      type: Boolean,
      default: true
    },
    iconName: {
      type: String,
      default: ''
    }
  },
  created: function created() {},
  methods: {
    onRefresh: function onRefresh() {
      this.$emit('onRefresh');
    }
  },
  computed: {
    iconNameValue: function iconNameValue() {
      if (this.iconName === '') {
        return;
      }

      return _defineProperty({}, "icon-".concat(this.iconName), true);
    }
  }
};